import React from "react";
import "./BannedMeet.scss"
import Avatar from "../../../../components/Avatar";
import Icon from "../../../../components/Icon";
import _ from "lodash";

const genderToString = {
    1 : 'homme',
    2 : 'femme',
    3 : 'couple-hetero'
}
const AvatarList = (gender) =>{

    if(genderToString[gender]){
        gender = genderToString[gender];
        return [`https://tools.emstat.fr/comparateur-dating/profils-voissa/${gender}/1.jpeg`, `https://tools.emstat.fr/comparateur-dating/profils-voissa/${gender}/2.jpeg`, `https://tools.emstat.fr/comparateur-dating/profils-voissa/${gender}/3.jpeg`, `https://tools.emstat.fr/comparateur-dating/profils-voissa/${gender}/4.jpeg` , `https://tools.emstat.fr/comparateur-dating/profils-voissa/${gender}/5.jpeg`]
    }
    else{
        return ['', '', '', '', ''];
    }
}

const defaultAvatarGender = (gender = 1) =>{
    let avatar = classGenders[gender] || "gender-man";
    return `https://www.voissa.com/images/avatars/${avatar}.jpg`;
}

const classGenders = {
    1: 'gender-man',
    2: 'gender-woman',
    3: 'gender-couple',
    4: 'gender-couple-lesbian',
    5: 'gender-couple-gay',
    6: 'gender-trav',
    guest: 'guest',
    group: 'group'
};

const BannerMeet = (props) => {
    let {username = "", gender = 0, avatar = ""} = props;
    gender = parseInt(gender);
    let isDisplay = [1,2,3].includes(gender);
    let urlAvatar = avatar;
    if(urlAvatar === ""){
        urlAvatar = defaultAvatarGender(gender);
    }

    let cta = [
        {label : "Les rencontres de Voissa", source : "bannprofil_les_rencontres_de_voissa"},
        {label : "Les plans hot de Voissa", source : "bannprofil_les_plans_hot_de_voissa"}
    ];

    let currentCta = _.sample(cta);

    return isDisplay ? (
        <div id="banner-rencontre" className="container">
            <div className="banner-rencontre">
                <div className="banner-rencontre-name">
                    <Avatar avatar={avatar} gender={gender}/>
                    <p>Tu veux rencontrer d'autres<br /> membres comme <b>{username}</b></p>
                </div>
                <div className="banner-rencontre-more">
                    <div className="banner-rencontre-imgs">
                        {AvatarList(gender).map((item, index) =>(
                            <Avatar key={index} avatar={item} gender={gender} height={45} width={45}/>
                        ))}
                    </div>

                    <a href={`/comparateur/rencontres?source=${currentCta.source}&gender=${genderToString[gender]}&member=${username}&avatar=${urlAvatar}`} className="banner-rencontre-cta">
                        {currentCta.label}
                        <Icon type={"big-arrow-right"} />
                    </a>
                </div>
            </div>
        </div>
    ) : null;
};

export default BannerMeet;

